import type { ReactNode } from "react";
import { BrowserRouter } from "react-router-dom";
import {
  AppInitializer,
  AppInitializerContent,
  AppUpdateWatcher,
  VybePresenceConnector,
} from "@/components/providers";
import VybeTraderClientProvider from "@/vybe-trader-client/connection/providers";
import { ThemeProvider } from "@/contexts/theme-context";
import { Toaster } from "@/shadcn-components/ui/sonner";

export function createVybeApp(routes: ReactNode) {
  return function VybeApp() {
    return (
      <ThemeProvider defaultTheme="dark" storageKey="mt6-ui-theme">
        <AppInitializer>
          <VybeTraderClientProvider>
            <VybePresenceConnector />
            <AppUpdateWatcher />
            <AppInitializerContent>
              <BrowserRouter>{routes}</BrowserRouter>
            </AppInitializerContent>
          </VybeTraderClientProvider>
        </AppInitializer>
        <Toaster />
      </ThemeProvider>
    );
  };
}
